import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tracker-vehicle-state',
  templateUrl: './tracker-vehicle-state.component.html',
  styleUrl: './tracker-vehicle-state.component.css'
})
export class TrackerVehicleStateComponent implements OnChanges {

  @Input() states: { name: string, value: number, backgroundColor: string, textColor: string, key?: string, selectedBgColor?: string, trackerBgColor?: string, selectedFontColor?: string }[];
  @Input() trackerFilters: any;
  @Output() selectedState = new EventEmitter<any>();
  public selectedVehicleState : any = ['allVehicle'];

  handleVehicleState(key: string) {
    this.selectedState.emit(key);
    if(key && key?.length) {
      if(this.selectedVehicleState?.includes(key)) {
        this.selectedVehicleState = this.selectedVehicleState?.filter(item => item !== key);
      } else {
        this.selectedVehicleState = this.selectedVehicleState?.filter(item => item !== 'allVehicle');
        this.selectedVehicleState?.push(key);
      }
      if(!this.selectedVehicleState?.length) {
        this.selectedVehicleState = ['allVehicle'];
      }
      // this.selectedVehicleState = this.selectedVehicleState?.includes(key) ? this.selectedVehicleState?.filter(item => item !== key) : (this.selectedVehicleState?.push(key));
    } 
  }

  ngOnChanges() : any {
    if(!this.trackerFilters || (this.trackerFilters && !Object.keys(this.trackerFilters)?.length)) {
      this.selectedVehicleState = ['allVehicle'];
    } else {
      if(!this.trackerFilters?.operationalStatus?.length) {
        this.selectedVehicleState = ['allVehicle'];
      } else {
        this.selectedVehicleState = [...this.trackerFilters?.operationalStatus];
        // this.selectedVehicleState = null;
      }
    }
  }
}
